module.exports = __webpack_public_path__ + "img/Pause.cbd01c27.svg";